import { ProfileModalV4Component } from "@circle-react/components/ProfileModalV4/ProfileModal";
import { createCompassModalSwitcher } from "@circle-react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { ProfileModalV3UIKitComponent } from "./ProfileModalV3UIKitComponent";

export interface ProfileModalV3Props {
  memberPublicId: string;
  params?: {
    shouldOpenInNewTab?: boolean;
    recommendation_id?: number;
  };
}

export const useProfileModalV3 = createCompassModalSwitcher(
  ProfileModalV4Component,
  ProfileModalV3UIKitComponent,
);
